import {
	provideHttpClient,
	withInterceptorsFromDi,
} from "@angular/common/http";
import {
	type ApplicationConfig,
	inject,
	APP_INITIALIZER,
	provideAppInitializer,
	provideBrowserGlobalErrorListeners,
	provideZonelessChangeDetection,
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter, withViewTransitions } from "@angular/router";
import Aura from "@primeuix/themes/aura";
import { providePrimeNG } from "primeng/config";
import { provideAngularQuery } from "@tanstack/angular-query-experimental";
import { AUTH_CONFIG, AuthService, queryClient } from "@magpie/services";
import { ThemeService } from "../themes";
import { appRoutes } from "./app.routes";

/**
 * Initialize auth state before app starts
 * This ensures session is loaded before routing begins
 */
function initializeAuth() {
	const authService = inject(AuthService);
	return () => authService.initialize();
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideZonelessChangeDetection(),
		provideRouter(
			appRoutes,
			// withViewTransitions()
		),
		provideHttpClient(withInterceptorsFromDi()),
		provideAnimationsAsync(),
		provideAngularQuery(queryClient),
		{ provide: AUTH_CONFIG, useValue: { enableAnonymousSignIn: false } },
		providePrimeNG({
			theme: {
				preset: Aura,
				options: {
					darkModeSelector: ".p-dark",
				},
			},
		}),
		{
			provide: APP_INITIALIZER,
			useFactory: initializeAuth,
			multi: true,
		},
		provideAppInitializer(() => {
			void inject(ThemeService);
		}),
	],
};
